/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".exampleCheckbox_aa1ad5e6{margin:10px 0}.exampleLabel_aa1ad5e6{margin:10px 0}\n"}]);
export const exampleCheckbox = "exampleCheckbox_aa1ad5e6";
export const exampleLabel = "exampleLabel_aa1ad5e6";